import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import DevicesIcon from '@mui/icons-material/Devices'
import LightModeIcon from '@mui/icons-material/LightMode'
import LoginIcon from '@mui/icons-material/Login'
import NotesIcon from '@mui/icons-material/Notes'
import { Link } from 'react-router'
import cnergiLogo from '../resources/CNERGI_PNG@4x.png'
import { getLoginSession } from '../services/authApi'
import './MobilePage.css'

function getMobileUserName() {
  const user = getLoginSession()?.user || {}
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ')

  return user.fullName || user.name || fullName || user.email || ''
}

function MobilePage({ isDarkMode = false, onToggleTheme }) {
  const userName = getMobileUserName()
  const primaryAction = userName ? '/mobile/maindash' : '/mobile/login'

  return (
    <main className="mobile-page">
      <header className="mobile-page__topbar">
        <Link className="mobile-page__brand" to="/" aria-label="CNERGI home">
          <img src={cnergiLogo} alt="CNERGI" />
        </Link>

        <button
          className="mobile-page__theme-toggle"
          type="button"
          aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={onToggleTheme}
        >
          {isDarkMode ? <LightModeIcon aria-hidden="true" /> : <DarkModeIcon aria-hidden="true" />}
        </button>
      </header>

      <section className="mobile-page__hero" aria-labelledby="mobile-page-title">
        <p className="mobile-page__eyebrow">CNERGI Mobile</p>
        <h1 id="mobile-page-title">Monitor energy operations from the field.</h1>
        <p>
          {userName
            ? `Signed in as ${userName}.`
            : 'Use the mobile portal to reach your dashboard, devices, and logs quickly.'}
        </p>

        <Link className="mobile-page__primary-action" to={primaryAction}>
          {userName ? <DashboardIcon aria-hidden="true" /> : <LoginIcon aria-hidden="true" />}
          <span>{userName ? 'Open Dashboard' : 'Sign In'}</span>
          <ArrowForwardIcon aria-hidden="true" />
        </Link>
      </section>

      <section className="mobile-page__quick-actions" aria-label="Mobile quick actions">
        <Link className="mobile-page__quick-action" to="/mobile/maindash">
          <DashboardIcon aria-hidden="true" />
          <span>
            <strong>Main Dashboard</strong>
            <small>Fleet overview and alerts</small>
          </span>
        </Link>

        <Link className="mobile-page__quick-action" to="/maindash/devices">
          <DevicesIcon aria-hidden="true" />
          <span>
            <strong>Devices</strong>
            <small>Open assigned EMS units</small>
          </span>
        </Link>

        <Link className="mobile-page__quick-action" to="/mobile/dashboard">
          <NotesIcon aria-hidden="true" />
          <span>
            <strong>Recent Logs</strong>
            <small>Review import and export readings</small>
          </span>
        </Link>
      </section>
    </main>
  )
}

export default MobilePage
